import React, { useState, useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { accordionData } from '../../data/accordionData'
import { cancelModalContent } from '../../data/modalContentData'
import {
  confirmInstructionCardData,
  sharePeriodInformationCard,
  manageShareInformationCard,
} from '../../data/pageInfoCardData'
import PageWrapper from '../../components/PageWrapper'
import PageContentWrapper from '../../components/PageWrapper/PageContentWrapper'
import PageHeader from '../../components/PageHeader'
import InstructionCard from '../../components/InstructionCard'
import Accordion from '../../components/Accordion'
import InformationCard from '../../components/InformationCard'
import DirectionLink from '../../components/DirectionLink'
import PageFooter from '../../components/PageFooter'
import PageModal from '../../components/PageModal'

import AccessDataContext from '../../Context'

const ConfirmShare = () => {
  const navigate = useNavigate()
  const [openModal, setOpenModal] = useState(false)
  const [navModalBtnFocused, setNavModalBtnFocused] = useState(false)
  useEffect(() => {
    if (navModalBtnFocused) {
      setNavModalBtnFocused(false)
    }
  }, [navModalBtnFocused])
  function closeModal() {
    setOpenModal(false)
    setNavModalBtnFocused(true)
  }

  const { accessDataType } = useContext(AccessDataContext)
  const filterAccordionData = accordionData.filter((item) =>
    accessDataType.includes(item.title)
  )
  const AccordionData = {
    title: 'Data requested',
    data: filterAccordionData,
  }

  const DirectLinkData = {
    text: 'View our CDR policy (2 min read)',
    direction: 'right',
    link: '',
    isDepenednt: true,
  }
  const PageFooterData = {
    title: 'Do you allow us to share your data with CompareBanks?',
    leftButton: 'Deny',
    leftButtonFunc: () => setOpenModal(!openModal),
    navModalBtnFocused: navModalBtnFocused,
    rightButton: 'Authorise',
    rightButtonFunc: () => navigate('/authorsing'),
    leftButtonLabel:
      'Deny button, to open the cancel process modal double click here',
    rightButtonLabel:
      'Authorise button, to authorised data sharing with CompareBanks double click here',
  }

  const pageModalData = {
    isOpen: openModal,
    onClose: () => closeModal(),
    data: {
      ...cancelModalContent,
      leftButton: 'No',
      leftButtonFunc: () => closeModal(),
      rightButton: 'Yes',
      rightButtonFunc: () => navigate('/process-cancel'),
    },
  }

  return (
    <PageWrapper isModalOpen={openModal}>
      <Helmet>
        <title>Confirm what we’ll share</title>
        <link rel="icon" href="./asset/bankIcon.svg" />
      </Helmet>
      <PageContentWrapper isModalOpen={openModal}>
        <PageHeader
          headerTitle="Bank 1"
          workflow="Auth"
          isFocused={true}
          titleLabel="banks 1: Confirm what we’ll share"
        />
        <InstructionCard {...confirmInstructionCardData} />
        <Accordion {...AccordionData} />
        <InformationCard {...sharePeriodInformationCard} />
        <InformationCard {...manageShareInformationCard} />
        <DirectionLink {...DirectLinkData} />
      </PageContentWrapper>
      <PageFooter {...PageFooterData} />
      <PageModal {...pageModalData} />
    </PageWrapper>
  )
}
export default ConfirmShare
